import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Store, User, MessageCircle, Settings, FileText } from 'lucide-react';
import { useEffectiveSerial } from '@/hooks/useEffectiveSerial';
import Gleap from 'gleap';

const BottomNavigation: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { serial } = useEffectiveSerial();
  const [isSupportOpen, setIsSupportOpen] = useState(false);

  // Don't show navigation on device selector page
  if (location.pathname === '/device-selector') {
    return null;
  }

  const handleSupportClick = () => {
    Gleap.startConversation();
    setIsSupportOpen(true);
  };

  const handleNavClick = (path: string) => {
    Gleap.close();
    setIsSupportOpen(false);
    navigate(path);
  };

  const tabs = [
    {
      id: 'support',
      label: 'Support',
      icon: MessageCircle,
      action: handleSupportClick,
      isActive: isSupportOpen
    },
    {
      id: 'appstore',
      label: 'Apps',
      icon: Store,
      path: `/${serial}`,
      action: () => handleNavClick(`/${serial}`),
      isActive: !isSupportOpen && location.pathname === `/${serial}`
    },
    {
      id: 'settings',
      label: 'Settings',
      icon: Settings,
      path: `/${serial}/settings`,
      action: () => handleNavClick(`/${serial}/settings`),
      isActive: !isSupportOpen && location.pathname.startsWith(`/${serial}/settings`)
    },
    {
      id: 'general',
      label: 'General',
      icon: User,
      path: `/${serial}/general`,
      action: () => handleNavClick(`/${serial}/general`),
      isActive: !isSupportOpen && location.pathname === `/${serial}/general`
    },
    {
      id: 'requests',
      label: 'Requests',
      icon: FileText,
      path: `/${serial}/requests`,
      action: () => handleNavClick(`/${serial}/requests`),
      isActive: !isSupportOpen && location.pathname === `/${serial}/requests`
    }
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-background/95 backdrop-blur-lg border-t border-border/40 z-[2147483647] safe-area-bottom">
      <div className="flex items-center justify-around h-[52px] max-w-lg mx-auto px-2">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          const active = tab.isActive;
          
          return (
            <button
              key={tab.id}
              onClick={tab.action}
              className={`flex flex-col items-center justify-center min-w-[56px] h-full transition-colors active:opacity-70`}
            >
              <div className={`relative ${active ? '' : ''}`}>
                <Icon 
                  className={`w-[22px] h-[22px] transition-colors ${
                    active 
                      ? 'text-primary' 
                      : 'text-muted-foreground'
                  }`} 
                  strokeWidth={active ? 2.5 : 1.5}
                  fill={active ? 'currentColor' : 'none'}
                />
              </div>
              <span className={`text-[10px] mt-0.5 font-medium transition-colors ${
                active 
                  ? 'text-primary' 
                  : 'text-muted-foreground'
              }`}>
                {tab.label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default BottomNavigation;
